<!-- @format -->
@if (filterShouldBeDisplayed()) {
  @if (isExposedFilter()) {
    <ng-container [ngTemplateOutlet]="filterTypesTemplate"></ng-container>
  } @else {
    <hmf-accordion
      data-filter-accordion
      [id]="filter()?.attrIdentifier | filterId:'accordion'"
      [label]="filter().attrName === GTGT_FILTER_NAME ? GTGT_TITLE : filter().attrName"
      [subLabel]="filter().attrName === GTGT_FILTER_NAME ? '' : selectedSubheaders()"
      size="large"
      [expandOverContent]="false"
      [variant]="'no-outlined'"
      (focus)="onAccordionFocus()"
      [active]="defaultOpen()"
      (activeChange)="onAccordionActiveChanged($event)"
    >
      <div id="filter-wrapper"
           ngProjectAs="customAccordionContent">
        <ng-container [ngTemplateOutlet]="filterTypesTemplate"></ng-container>
      </div>
      @if (filterType() === FilterType.Ratings && selectedOptions().length > 0) {
        <div ngProjectAs="accordionHeaderRightContent">
          <hmf-action-text
            variant="tertiary"
            (click)="handleClearClick($event)">
            Clear
          </hmf-action-text>
        </div>
      }
    </hmf-accordion>
  }
}
<ng-template #filterTypesTemplate>
  <div>
    @switch (filterType()) {
      @case (FilterType.Brand) {
        <plp-components-brand-filter
          [id]="filter()?.attrIdentifier | filterId:'brand'"
          [filterOptions]="filter().valueList"
          [attributeName]="filter().attrName"
          [attributeIdentifier]="filter().attrIdentifier"
          [selectedOptions]="selectedOptions()"
          [isMobile]="isMobile()"
          [disabled]="disabled()"
          [allowCollapsing]="!isExposedFilter()"
          [defaultShowMore]="showMore()"
          (selectedFilter)="setSelectedFilter($event)"
          (showMoreChange)="
						facetToggleChanged(filter().attrName, true, $event)"
        >
        </plp-components-brand-filter>
      }
      @case (FilterType.Price) {
        <plp-components-price-filter
          [id]="filter()?.attrIdentifier | filterId:'price'"
          [filterOptions]="filter().valueList"
          [attributeName]="filter().attrName"
          [attributeIdentifier]="filter().attrIdentifier"
          [selectedOptions]="selectedOptions()"
          [isMobile]="isMobile()"
          [disabled]="disabled()"
          [allowCollapsing]="!isExposedFilter()"
          [defaultShowMore]="showMore()"
          (selectedFilter)="setSelectedFilter($event)"
          (showMoreChange)="
						facetToggleChanged(filter().attrName, true, $event)"
        >
        </plp-components-price-filter>
      }
      @case (FilterType.Ratings) {
        <plp-components-rating-filter
          [id]="filter()?.attrIdentifier | filterId:'rating'"
          [filterOptions]="filter().valueList"
          [attributeName]="filter().attrName"
          [attributeIdentifier]="filter().attrIdentifier"
          [selectedOptions]="selectedOptions()"
          [isMobile]="isMobile()"
          [disabled]="disabled()"
          [allowCollapsing]="!isExposedFilter()"
          (selectedFilter)="setSelectedFilter($event, true)"
          (showMoreChange)="
						facetToggleChanged(filter().attrName, true, $event)"
        ></plp-components-rating-filter>
      }
      @case (FilterType.Size) {
        <plp-components-size-filter
          [id]="filter()?.attrIdentifier | filterId:'size'"
          [filterOptions]="filter().valueList"
          [attributeIdentifier]="filter().attrIdentifier"
          [attributeName]="filter().attrName"
          [selectedOptions]="selectedOptions()"
          [isMobile]="isMobile()"
          [defaultOpen]="defaultOpen()"
          [allowCollapsing]="!isExposedFilter()"
          [defaultShowMore]="showMore()"
          (selectedFilter)="setSelectedFilter($event)"
          (showMoreChange)="facetToggleChanged(filter().attrName, true, $event)"
        >
        </plp-components-size-filter>
      }
      @case (FilterType.Category) {
        <plp-components-category-filter
          [id]="filter()?.attrIdentifier | filterId:'category'"
          [filterOptions]="filter().valueList"
          [attributeName]="filter().attrName"
          [attributeIdentifier]="filter().attrIdentifier"
          [selectedOptions]="selectedOptions()"
          [isMobile]="isMobile()"
          [disabled]="disabled()"
          [allowCollapsing]="!isExposedFilter()"
          [defaultShowMore]="showMore()"
          [defaultOpen]="defaultOpen()"
          [isPlp3Template]="isPlp3Template()"
          [categoryDetails]="productListCategoryDetails()"
          (selectedFilter)="setSelectedFilter($event)"
          (showMoreChange)="facetToggleChanged(filter().attrName, true, $event)"
        >
        </plp-components-category-filter>
      }
      @default {
        <plp-components-standard-filter
          [id]="filter()?.attrIdentifier | filterId:'standard'"
          [filterOptions]="filter().valueList"
          [attributeName]="filter().attrName"
          [attributeIdentifier]="filter().attrIdentifier"
          [selectedOptions]="selectedOptions()"
          [isMobile]="isMobile()"
          [disabled]="disabled()"
          [allowCollapsing]="!isExposedFilter()"
          [defaultShowMore]="showMore()"
          (selectedFilter)="setSelectedFilter($event)"
          (showMoreChange)="
						facetToggleChanged(filter().attrName, true, $event)"
        >
        </plp-components-standard-filter>
      }
    }
  </div>
</ng-template>
